/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ModerateStreamContainer_story = {
    readonly id: string;
    readonly canModerate: boolean;
    readonly isArchived: boolean;
    readonly isArchiving: boolean;
    readonly " $refType": "ModerateStreamContainer_story";
};
export type ModerateStreamContainer_story$data = ModerateStreamContainer_story;
export type ModerateStreamContainer_story$key = {
    readonly " $data"?: ModerateStreamContainer_story$data;
    readonly " $fragmentRefs": FragmentRefs<"ModerateStreamContainer_story">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ModerateStreamContainer_story",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canModerate",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isArchived",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isArchiving",
            "storageKey": null
        }
    ],
    "type": "Story",
    "abstractKey": null
} as any);
(node as any).hash = '50ff0d9676374bdf6ec488de6acd66c6';
export default node;
